import React, { useState, useEffect } from "react";
import { Shield, BarChart3, Users, Scale } from "lucide-react";

import Banner from "../components/Banner";
import bannerimg from "../assets/img/termbg.jpg";
import CTA from "../components/CTA";

const sections = [
  { id: "intro", title: "1. Introduction" },
  { id: "purpose", title: "2. Platform Purpose" },
  { id: "information", title: "3. User Eligibility" },
  { id: "responsibilities", title: "4. User Responsibilities" },
  { id: "ownership", title: "5. Content Ownership" },
  { id: "research", title: "6. Research & Survey Usage" },
  { id: "rewards", title: "7. Points & Rewards System" },
  { id: "suspension", title: "8. Account Suspension" },
  { id: "liability", title: "9. Limitation of Liability" },
  { id: "privacy", title: "10. Privacy" },
  { id: "changesterms", title: "11. Changes to Terms" },
  { id: "contactus", title: "12. Contact" },
];

function TermsAndConditions() {
    const [active, setActive] = useState("intro");

  
    useEffect(() => {
        const handleScroll = () => {
            const termsSections = [...document.querySelectorAll(".prtext .rightpart section[id]")];
            const current = termsSections.reduce((selected, section) =>
              section.getBoundingClientRect().top <= 150 ? section.id : selected,
            "intro");

            if (current) {
            setActive(current);
            }
        };

        handleScroll();
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
        }, []);

  return (
    <>
      <div className="position-relative">

        <Banner
          containerWidth="w-50"
          title="Built on Trust. Backed by Transparency"
          subtitle="These Terms & Conditions explain how we protect your data, define platform usage, and ensure a secure survey experience for everyone."
          bgImage={bannerimg}
          headingcenter="text-center"
        />

        <section className="bg-white px-3 ptb60px pb100px prtext">
          <div className="container">
            <div className="row g-5 stickyrow">
                {/* SIDEBAR */} 
                <div className="col-lg-3 leftsidebar">
                    <div className="sticky-sidebar">
                    <h5 className="fw-bold">Table of Contents</h5>

                    <ul id="sidebar-nav" className="nav flex-column mt-3">
                            {sections.map((item) => (
                                <li key={item.id}>
                                <a
                                    href={`#${item.id}`}
                                    className={`d-block px-3 py-3 rounded text-decoration-none ${
                                    active === item.id
                                        ? "bgbluebox2 fw-semibold"
                                        : "text-secondary"
                                    }`}
                                    style={{ fontSize: "15px" }}
                                >
                                    {item.title}
                                </a>
                                </li>
                            ))}
                            </ul>
                        </div>
                </div>
                {/* RIGHT CONTENT */}
                <div className="col-lg-9 rightpart">

                    {/* SECTION 1 */}
                    <section className="mb50px" id="intro" data-aos="fade-up">
                        <h2>
                        <span className="">1.</span> Introduction
                        </h2>
                        <p className="mb-2 fw-bold">Welcome to Industry & People (I&P)</p>

                        <p className="">By accessing or using our platform, you agree to comply with these Terms & Conditions. If you do not agree, please do not use the platform. </p>
                        
                    </section>

                    {/* SECTION 2 */}
                    <section className="mb50px" id="purpose" data-aos="fade-up">
                        <h2>
                        <span className="">2.</span> Platform Purpose
                        </h2>

                        <p className="">
                        I&P is a professional community designed to: 
                        </p>
                        <ul className="">
                            <li>Share insights</li>
                            <li>Conduct primary research </li>
                            <li>Exchange knowledge across industries</li>
                        </ul>
                        
                    </section>
                    
                    <section className="mb50px" id="information" data-aos="fade-up">
                        <h2>
                            <span className="">3.</span> User Eligibility
                        </h2>

                        <p className="">
                            By using this platform, you confirm that: 
                        </p>                            

                        <ul className="">
                            <li>You are at least 18 years old </li>
                            <li>You provide accurate and truthful information </li>
                            <li>You use the platform for professional purposes only </li>
                        </ul>
                    </section>                

                    <section className="mb50px" id="responsibilities" data-aos="fade-up">
                        <h2>
                            <span className="">4.</span> User Responsibilities 
                        </h2>

                        <p className="fw-bold">
                            You agree Not to:
                        </p>

                        <ul className="mb-4">
                            <li>Share false, misleading, or harmful information </li>
                            <li>Violate any laws or regulations </li> 
                            <li>Misuse research data or insights </li>
                            <li>Post offensive, abusive, or inappropriate content </li>
                        </ul>

                        <p className="">
                            We maintain a professional, insight-driven environment.
                        </p>
                        
                    </section>

                    <section className="mb50px" id="ownership" data-aos="fade-up">
                        <h2>
                            <span className="">5.</span> Content Ownership 
                        </h2>
                        
                        <ul className="fullrow">
                            <li>You retain ownership of the content you share </li>
                            <li>By posting, you grant I&P a non-exclusive license to use, display, and distribute it within the platform </li> 
                            <li>We may use anonymized insights for research and improvement </li>
                        </ul> 
                        
                    </section>

                    <section className="mb50px" id="research" data-aos="fade-up">
                        <h2>
                            <span className="">6.</span> Research & Survey Usage
                        </h2>
                        
                        <ul className="fullrow">
                            <li>Surveys are created by users for research purposes </li>
                            <li>Responses may be used in aggregated (non-identifiable) format </li>
                            <li>Users must not misuse collected data </li>
                        </ul>
                    </section>

                    <section className="mb50px" id="rewards" data-aos="fade-up">
                        <h2>
                            <span className="">7.</span> Points & Rewards System
                        </h2>

                        <p className="">
                            We use cookies to:
                        </p>
                        
                        <ul className="fullrow">
                            <li>Users may earn points by participating in surveys </li>
                            <li>Points can be used for research or redeemed (if applicable) </li>
                            <li><strong>I&P</strong> reserves the right to modify or revoke points in case of misuse </li>
                        </ul>
                    </section>

                    <section className="mb50px" id="suspension" data-aos="fade-up">
                        <h2>
                            <span className="">8.</span> Account Suspension
                        </h2>

                        <p className="fw-bold">
                            We reserve the right to: 
                        </p>

                        <ul className="mb-4">
                            <li>Suspend or terminate accounts </li>
                            <li>Remove content violating guidelines </li>
                        </ul>

                            <p className="fw-bold">
                            Without prior notice if misuse is detected.  
                        </p>
                    </section>

                    <section className="mb50px" id="liability" data-aos="fade-up">
                        <h2>
                            <span className="">9.</span> Limitation of Liability
                        </h2>

                        <p className="fw-bold">
                            I&P is not responsible for: 
                        </p>

                        <ul className="fullrow">
                            <li>Decisions made based on shared insights </li>
                            <li>Accuracy of user-generated content </li>
                            <li>Any indirect or consequential damages </li>
                        </ul>
                    </section>

                    <section className="mb50px" id="privacy" data-aos="fade-up">
                        <h2>
                            <span className="">10.</span> Privacy
                        </h2>

                        <p className="">
                            Your use of the platform is also governed by our Privacy Policy. 
                        </p>
                        
                    </section> 

                    <section className="mb50px" id="changesterms" data-aos="fade-up">
                        <h2>
                            <span className="">11.</span> Changes to Terms
                        </h2>

                        <p className="">
                            We may update these terms at any time. 
                        </p>

                        <p className="textred">
                            Continued use = acceptance of updated terms. 
                        </p>
                    </section>

                    <section className="mb50px" id="contactus" data-aos="fade-up">
                        <h2>
                            <span className="">12.</span> Contact
                        </h2>

                        <p className="textbluecolor fs-15">
                            support@inpcommunity.com
                        </p>
                    </section>

                </div>
            </div>
          </div>
        </section>

        <CTA />
      </div>
    </>
  );
}

export default TermsAndConditions;
